export type PointListRow = {
  id: string;
  title: string;
  amountText: string;
  date?: string;
  statusLabel?: string;
  isMinus?: boolean;
};

interface Props {
  items: PointListRow[];
  emptyText?: string;
  summaryPlus?: number;
  summaryMinus?: number;
}

export default function OnelivePointList({
  items,
  emptyText = '자료가 없습니다.',
  summaryPlus,
  summaryMinus,
}: Props) {
  if (items.length === 0) {
    return (
      <ul className="point_list onelive-point-list">
        <li>{emptyText}</li>
      </ul>
    );
  }

  const plus = summaryPlus ?? items
    .filter((row) => !row.isMinus)
    .reduce((sum, row) => sum + parseAmount(row.amountText), 0);
  const minus = summaryMinus ?? items
    .filter((row) => row.isMinus)
    .reduce((sum, row) => sum + parseAmount(row.amountText), 0);

  return (
    <ul className="point_list onelive-point-list">
      {items.map((row) => (
        <li key={row.id} className={row.isMinus ? 'point_use' : undefined}>
          <div className="point_row">
            <div className="point_main">
              <div className="point_tit">
                {row.statusLabel ? (
                  <span className="onelive-point-status">{row.statusLabel}</span>
                ) : null}
                {row.title}
              </div>
              {row.date ? (
                <div className="point_date1">
                  <i className="fa fa-clock-o" aria-hidden="true" />
                  {' '}
                  {row.date}
                </div>
              ) : null}
            </div>
            <span className={`point_num${row.isMinus ? ' is-minus' : ''}`}>{row.amountText}</span>
          </div>
        </li>
      ))}
      {summaryPlus !== undefined || summaryMinus !== undefined ? (
        <li className="point_status">
          소계
          <span>증가: +{formatSummary(plus)}</span>
          <span>차감: {formatSummary(minus)}, </span>
        </li>
      ) : null}
    </ul>
  );
}

function parseAmount(text: string): number {
  const normalized = text.replace(/[^\d-]/g, '');
  const value = Number(normalized);
  return Number.isFinite(value) ? Math.abs(value) : 0;
}

function formatSummary(value: number): string {
  return value.toLocaleString('ko-KR');
}
